export default "__VITE_ASSET__BfLWhyz2__"